{
  "version": "buyer-profile.v1",
  "note": "Names the checklist interpolates into item text. The default is the EBOS stack the buyer-side diligence checklist was written for. A deal overrides any field with deals.js buyerProfile.",
  "name": "EBOS",
  "backOffice": "PakEnergy",
  "closingCounsel": "Gardere",
  "environmentalConsultant": "Comm Engineering",
  "electricProvider": "Xcel"
}
